import ResultsPatents from './resultsPatents.js';
export default ResultsPatents;
